/* Mobilni meni je pripet na vrh strani. Ob odprtju tema obnovi prejšnje drsenje,
   zato je meni na strani izdelka ostal pod vsebino. Ob odprtju gremo na vrh. */
(function () {
  document.addEventListener('drawerOpen', function () {
    [0, 80, 350].forEach(function (ms) {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, ms);
    });
  });
})();
